import clsx from "clsx";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import classes from "./Input.module.css";

export const Input = ({
  type = "text",
  label,
  label2,
  value,
  onChange,
  noBorder = false,
  placeholder = "Search Here",
  disabled = false,
  parentCustomStyle,
  customStyle,
  inputStyle,
  labelStyle,
  id,
  containerClass = "",
  errorText = "",
  leftIcon,
  rightIcon,
  onKeyPress,
  regexType,
  isOptional = false,
  counter,
  className,
  children,
  onClick,
  ...props
}) => {
  const [passToggle, setPassToggle] = useState(false);

  let inputType = type;
  if (inputType === "number") {
    regexType = "number";
    inputType = "string";
  }

  if (regexType === "number") {
    console.log("value ==>", value);
    value = Number(String(value)?.replace(/[^\d]/g, "")).toLocaleString();
  }
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (regexType === "number") {
      onChange(Number(inputValue.replace(/[^\d]/g, ""))); // Replace non-numeric characters
    } else {
      onChange(inputValue);
    }
  };

  return (
    <div
      onClick={(e) => {
        if (typeof onClick === "function") onClick(e);
      }}
      className={clsx(classes.wrapper, {
        [classes.error]: errorText,
        [className]: className,
      })}
      style={parentCustomStyle}
    >
      {label && (
        <div className={classes.labelWrapper}>
          <label
            htmlFor={`input-${id || label}`}
            className={clsx(classes.labelText, {
              [classes.labelDisabled]: disabled,
            })}
            style={labelStyle}
          >
            {label} {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
          {counter && <span className={classes.counter}>{counter}</span>}
        </div>
      )}
      <div
        className={clsx(classes.container, containerClass, {
          [classes.noBorder]: noBorder,
        })}
        style={{ ...customStyle, ...(leftIcon && { paddingLeft: "20px" }) }}
      >
        {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}
        <input
          // value={regexType === "number" ? commaSeparatedValue : value}
          value={value}
          onChange={handleInputChange}
          onKeyPress={(e) =>
            onKeyPress &&
            ["Enter", "NumpadEnter"].includes(e.code) &&
            onKeyPress()
          }
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
            }
          }}
          // onBlur={() => {
          //   if (typeof value != "number") {
          //     onChange(value?.trim());
          //   }
          // }}
          disabled={disabled}
          placeholder={placeholder}
          type={passToggle ? "text" : inputType}
          id={`input-${id || label}`}
          className={clsx(classes.inputBox)}
          style={inputStyle}
          {...props}
        />
        {rightIcon ||
          (inputType === "password" && (
            <span className={classes.iconContainer}>
              {rightIcon && (
                <span className={classes.rightIcon}>{rightIcon}</span>
              )}
              {inputType === "password" &&
                (passToggle ? (
                  <IoEyeOutline
                    color="var(--icon-color)"
                    size={21}
                    className={classes.passwordIcon}
                    onClick={() => setPassToggle(!passToggle)}
                  />
                ) : (
                  <IoEyeOffOutline
                    color="var(--icon-color)"
                    size={21}
                    className={classes.passwordIcon}
                    onClick={() => setPassToggle(!passToggle)}
                  />
                ))}
            </span>
          ))}
        {children && <div className={classes.children}>{children}</div>}
      </div>
      {errorText && <p className={"errorText"}>{errorText}</p>}
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.oneOf(["text", "password", "number"]).isRequired,
  label: PropTypes.string,
  label2: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  noBorder: PropTypes.bool,
  disabled: PropTypes.bool,
  parentCustomStyle: PropTypes.object,
  customStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  errorText: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  onKeyPress: PropTypes.func,
  regexType: PropTypes.string,
  isOptional: PropTypes.bool,
};

Input.defaultProps = {
  type: "text",
  placeholder: "Search Here",
  value: "",
  noBorder: false,
  disabled: false,
  error: false,
  errorText: "",
  onChange: () => { },
};
